/**
 * CreateProjectForm Component
 */

import { pushNotification } from '../../../redux/actions/notifications';
import { requestCreateProject } from '../../../redux/actions/projects';
import { addProject } from './form';

import * as React from 'react';
import { connect } from 'react-redux';
import { Field } from 'redux-form';
import { VelocityComponent } from 'velocity-react';

import Button from '../../atoms/buttons/Button';
import TextField from '../../atoms/forms/TextField';
import { IconAddCircle } from '../../atoms/images/Icon';

interface IOwnProps {
  onCreateProject(): void;
}

interface IOwnState {
  hasError?: boolean;
}

type CreateProjectFormProps = IOwnProps & IDispatchProps;

class CreateProjectForm extends React.Component<CreateProjectFormProps, IOwnState> {

  constructor(props) {
    super(props);

    this.state = {};
  }

  onCreateProject = (name: string) => {
    if (!name) {
      this.setState({ hasError: true });
      return;
    }

    this.props.dispatch(addProject());
    this.props.onCreateProject();
    this.props.dispatch(requestCreateProject({
      input: { name },
      promise: {
        resolve: () => null,
        reject: (error) => {
          this.props.dispatch(pushNotification({
            autoDismiss: false,
            message: 'An error occured while creating the playlist. Please try again later.',
            state: 'error',
          }));
        },
      },
    }));
  }

  render() {
    return (
      <VelocityComponent
        animation={this.state.hasError ? 'callout.shake' : undefined}
        complete={() => this.setState({ hasError: false })}
      >
        <Field
          component={TextField}
          name="createProject"
          placeholder="New Playlist"
          icon={<IconAddCircle />}
          inlineButton={
            <Button
              label="Create"
              colorScheme="dark"
              onClick={this.onCreateProject}
            />
          }
          colorScheme="light"
          size="small"
          submitOnEnter
          withoutBorder
        />
      </VelocityComponent>
    );
  }
}

const ConnectedCreateProjectForm = connect<{}, {}, IOwnProps, IStoreState>(null)(CreateProjectForm);
export default ConnectedCreateProjectForm;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/public/components/pages/Projects/CreateProjectForm.tsx